package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.CharacterRepository

class CountCharactersUseCase(
    private val characterRepository: CharacterRepository
) {
    suspend operator fun invoke(userId: String): Result<Int> {
        return characterRepository.countCharactersByUserId(userId)
    }
}
